<template>
  <div id="mainNotification">
    <div class="notification-container">
      <div class="row" v-if="!checkMobileStatus">
        <div style="display: inline-block; vertical-align: sub">
          <img src="../assets/Vector10.png" />
          <span class="sans-font-style" style="vertical-align: middle; margin-left: 10px">{{ lang('Notifications') }}</span>
        </div>
      </div>

      <hr style="margin: 0px" />

      <div class="empty-notification-container row" v-if="arrobj_notificationList.length <= 0">
        <img src="../assets/notif1.png" style="margin: 0 auto" />
        <span style="display: block; margin: 0 auto">{{ notif_empty_message }}</span>
      </div>

      <div class="notification-list-container row" v-show="arrobj_notificationList.length > 0">
        <div class="notification-list-content" v-show="arrobj_notificationList.length > 0">
          <div class="notification-list">
            <!--                        :class="notifList.NotiRead === 'No' ? 'unread' : 'read'"-->
            <div
              class="each-notification-container"
              v-for="(notifList, index) of arrobj_notificationList"
              @click="notifList.NotiType === 'PostDirectMsg' ? clickEachDM(notifList) : clickOtherTypeNotif(notifList)"
            >
              <div class="left-notification-container">
                <img class="notif-img" src="../assets/boy.png" v-if="notifList.CreatedByProfileImage === '' || notifList.CreatedByProfileImage === undefined" />
                <img
                  class="notif-img"
                  :src="`data:image/jpg;base64, ${notifList.CreatedByProfileImage}`"
                  v-if="notifList.CreatedByProfileImage !== '' && notifList.CreatedByProfileImage !== undefined"
                />
              </div>

              <div class="right-notification-container">
                <div class="each-notif-content">
                  <div class="row" style="margin: 0px; padding: 0px">
                    <span class="sans-font-style--size-12" style="font-weight: bold">{{ notifList.CreatedByName }}</span>
                    <small class="date sans-font-style--size-12" style="margin-left: auto">{{ notifList.NotiCreatedOn_converted }}</small>
                  </div>

                  <div class="row" style="margin: 0px; padding: 0px">
                    <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'Update'">{{ postFeedMsg }}</span>
                    <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'FeedComment'">{{ postCommentFeedMsg }}</span>
                    <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'Broadcast'">{{ postBroadcastMsg }}</span>
                    <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'Portfolio'">{{ postPortfolioMsg }}</span>
                    <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'PostDirectMsg'">{{
                      lang('You have Message')
                    }}</span>
                  </div>
                </div>
              </div>

              <hr />
            </div>
          </div>
        </div>
      </div>

      <div v-show="checkMobileStatus && isMobileClick" style="position: fixed; z-index: 999; bottom: 50px; width: 100%">
        <button class="btn sans-font-style--size-12" style="background: #426dff; color: #ffffff; width: 100%" @click="hideMobileNotifModal()">
          {{ lang('Close') }}
        </button>
      </div>
    </div>

    <div class="mobile-notif-container" v-show="checkMobileStatus" @click="showMobileNotifModal()">
      <img v-show="!isMobileClick" src="../assets/Vector10.1.png" />
      <img v-show="isMobileClick" src="../assets/Vector10.png" />
    </div>

    <b-modal id="modal_MobileNotifList" ref="modal_MobileNotifList" centered :ok-title="lang('Confirm')" @ok="showMobileNotifModal" hide-header hide-footer>
      <div class="notification-list-content">
        <div class="empty-notification-container row" v-if="arrobj_notificationList.length <= 0">
          <img src="../assets/notif1.png" style="margin: 0 auto" />
          <span style="display: block; margin: 0 auto">{{ notif_empty_message }}</span>
        </div>

        <div class="notification-list" v-show="arrobj_notificationList.length > 0">
          <div
            class="each-notification-container"
            v-for="(notifList, index) of arrobj_notificationList"
            :class="notifList.NotiRead === 'No' ? 'unread' : 'read'"
            @click="notifList.NotiRead === 'No' ? updateNotifStatus(notifList, index) : accessToRelatedPage(notifList)"
          >
            <div class="left-notification-container">
              <img class="notif-img" src="../assets/boy.png" v-if="notifList.CreatedByProfileImage === '' || notifList.CreatedByProfileImage === undefined" />
              <img
                class="notif-img"
                :src="`data:image/jpg;base64, ${notifList.CreatedByProfileImage}`"
                v-if="notifList.CreatedByProfileImage !== '' && notifList.CreatedByProfileImage !== undefined"
              />
            </div>

            <div class="right-notification-container">
              <div class="each-notif-content">
                <div class="row" style="margin: 0px; padding: 0px">
                  <span class="sans-font-style--size-12" style="font-weight: bold">{{ notifList.CreatedByName }}</span>
                  <small class="date sans-font-style--size-12" style="margin-left: auto">{{ notifList.NotiCreatedOn_converted }}</small>
                </div>

                <div class="row" style="margin: 0px; padding: 0px">
                  <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'Update'">{{ postFeedMsg }}</span>
                  <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'FeedComment'">{{ postCommentFeedMsg }}</span>
                  <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'Broadcast'">{{ postBroadcastMsg }}</span>
                  <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'Portfolio'">{{ postPortfolioMsg }}</span>
                  <span class="sans-font-style--size-12" style="color: #828894" v-if="notifList.NotiType === 'PostDirectMsg'">{{
                    lang('You have Message')
                  }}</span>
                </div>
              </div>
            </div>

            <hr />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import $ from 'jquery'
import DataSource from '../data/datasource'
import { lang } from '../locale/index'
import moment from 'moment'

import { NotifEvent, notifGlobalVariable } from '../global/index.js'

export default {
  name: 'MainNotificationComponent',
  components: {},
  data() {
    return {
      isParent: '',
      notificationID: '',
      limit: 20,
      notif_empty_message: lang('Notif Empty Message'),
      postFeedMsg: lang('Post Feed Msg'),
      postCommentFeedMsg: lang('Post Comment Feed Msg'),
      postBroadcastMsg: lang('Post Broadcast Msg'),
      postPortfolioMsg: lang('Post Portfolio Msg'),
      notifAction: 'MarkAsRead',
      interNotif: '',
      totalUnread: 0,
      schoolID: '',
      numOfDays: '14',

      arrobj_notificationList: [],
      parentSchIds: [],

      hasBroadcastAlert: false,
      checkMobileStatus: false,
      isMobileClick: false,
    }
  },
  methods: {
    lang,

    async getNotificationList() {
      this.totalUnread = 0

      try {
        this.arrobj_notificationList = []
        this.notificationID = ''

        const notificationList = await DataSource.shared.getNotificationsByRowNumber(this.notificationID, this.limit, this.numOfDays)

        if (notificationList.Table) {
          notificationList.Table.forEach((object, index) => {
            if (index === notificationList.Table.length - 1) {
              this.notificationID = object.NotiID
            }

            if (object.NotiRead.toLowerCase() === 'no') {
              this.totalUnread = this.totalUnread + 1
            }

            object.NotiCreatedOn_converted = moment(String(object.NotiCreatedOn)).format('MM/DD/YYYY')
          })

          var filteredNotificationList = notificationList.Table.filter(function (el) {
            if (el.NotiType !== 'Portfolio') {
              return el
            }
            // return el;
          })

          this.arrobj_notificationList = filteredNotificationList
        }
      } catch (e) {
        this.result = e
      }
    },

    async loadMoreNotificationList() {
      try {
        const notificationList = await DataSource.shared.getNotificationsByRowNumber(this.notificationID, this.limit, this.numOfDays)

        if (notificationList.Table) {
          notificationList.Table.forEach((object, index) => {
            if (index === notificationList.Table.length - 1) {
              this.notificationID = object.NotiID
            }

            if (object.NotiRead.toLowerCase() === 'no') {
              this.totalUnread = this.totalUnread + 1
            }

            object.NotiCreatedOn_converted = moment(String(object.NotiCreatedOn)).format('MM/DD/YYYY')
          })

          var filteredNotificationList = notificationList.Table.filter(function (el) {
            if (el.NotiType !== 'Portfolio') {
              return el
            }
          })

          // this.arrobj_notificationList.push.apply(this.arrobj_notificationList, notificationList.Table);
          this.arrobj_notificationList.push.apply(this.arrobj_notificationList, filteredNotificationList)
        }
      } catch (e) {
        this.result = e
      }
    },

    async updateNotifStatus(notif /*, notifIndex*/) {
      const updatedNotifStatus = await DataSource.shared.updateNotificationsStatus(notif.NotiID, this.notifAction)

      if (updatedNotifStatus.code === '1') {
        this.arrobj_notificationList.forEach((object, index) => {
          if (object.NotiID === notif.NotiID) {
            object.NotiRead = 'Yes'
          }
        })
      }

      // if (updatedNotifStatus.code === '1') {
      //     this.$set(this.arrobj_notificationList[notifIndex], "NotiRead", "Yes");
      //
      //     this.totalUnread = this.totalUnread - 1;
      // } else {
      //     console.log(updatedNotifStatus.code);
      // }

      // this.accessToRelatedPage(notif);
    },

    async accessToRelatedPage(notif) {
      this.showNotificationList()
      this.$set(notifGlobalVariable, 'NotiValue', '')
      this.$set(notifGlobalVariable, 'NotiType', '')
      this.$set(notifGlobalVariable, 'NotiValue', notif.NotiValue)
      this.$set(notifGlobalVariable, 'NotiType', notif.NotiType)

      // this.$root.$emit("notificationType", notif);

      // if (notif.NotiType === "Update") {
      //     this.$router.push('/staffmainpage').catch(err => {});
      // }
      // else if (notif.NotiType === "FeedComment") {
      //     this.$router.push('/newfeed').catch(err => {});
      // } else if (notif.NotiType === "Broadcast") {
      //     this.$router.push('/newbroadcast').catch(err => {});
      // }
    },

    showNotificationList() {
      // console.log($(".mobile-notification-list-content").css("display"), "wakakak");
      if ($('.mobile-view .notif-container').css('display') === 'block') {
        $('.mobile-view .notif-container').hide()
      } else {
        $('.mobile-view .notif-container').show()
      }
    },

    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },

    showMobileNotifModal() {
      // this.isVisible = false;
      // this.$refs.modal_MobileNotifList.show();
      // this.getNotificationList();

      this.isMobileClick = true
      this.$emit('checkMobileNotif', this.isMobileClick)
    },

    hideMobileNotifModal() {
      // this.isVisible = false;
      // this.$refs.modal_MobileNotifList.hide();

      this.isMobileClick = false
      this.$emit('checkMobileNotif', this.isMobileClick)
    },

    clickEachDM(eachDM) {
      if (eachDM.NotiRead === 'No') {
        this.updateNotifStatus(eachDM)
      }

      this.$emit('passEachDM', eachDM)
    },

    clickOtherTypeNotif(eachNotif) {
      // if (eachNotif.NotiType === "Broadcast") {
      //     if (eachNotif.NotiRead === "No") {
      //         this.updateNotifStatus(eachNotif);
      //     }
      //
      //     let nType = "";
      //     nType = eachNotif.NotiType;
      //
      //     window.location.replace('/StaffMainpage?postID='+eachNotif.NotiValue+'&currentType='+nType);
      // }
    },

    broadcastAlert() {
      var objAlert = {}
      objAlert.pageType = 'broadcast'
      objAlert.hasAlert = this.hasBroadcastAlert

      this.$emit('changePageBroadcastAlert', objAlert)
    },
  },
  async mounted() {
    this.isMobile()

    this.totalUnread = 0
    const self = this
    await self.getNotificationList()

    if (Cookies.get('userTypeSession') === 'Parent') {
      self.hasBroadcastAlert = false

      var checkBroadcastAlert = self.arrobj_notificationList.some(function (el) {
        if (el.NotiType === 'Broadcast') {
          return el.NotiCreatedOn_converted >= moment().add(-2, 'days').format('MM/DD/YYYY')
        }
      })

      if (checkBroadcastAlert) {
        self.hasBroadcastAlert = true
        self.broadcastAlert()
      }
    }

    $(document).ready(function () {
      if (Cookies.get('userTypeSession') === 'Parent') {
        $(document).bind('contextmenu', function (e) {
          return false
        })
      }

      if (self.checkMobileStatus) {
        $('.topbar .mobile-notification-container .mobile-notif-container').remove()
        $('.mobile-notif-container').appendTo('.topbar .mobile-notification-container')
      }

      $('.notification-list-container').scroll(function () {
        let $this = $(this)

        const listElm = document.querySelector('.notification-list-container')
        // if (scrollPercent >= 80) {
        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          if (self.arrobj_notificationList.length % 10 === 0) {
            self.loadMoreNotificationList()
          }
        }
      })
    })
  },
  created() {
    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile)
    $('.notification-list-container').unbind('scroll')
  },
  watch: {},
  props: [],
}
</script>

<style scoped>
.notification-list-container {
  /*height: 100%;*/
  height: calc(100vh - 170px);
  overflow: auto;
}

.notification-container .row {
  margin: 10px 0px;
  padding: 15px;
}

.notification-list-content {
  width: 100%;
  text-align: left;
}

.each-notification-container {
  cursor: pointer;
}

.left-notification-container {
  display: inline-block;
  vertical-align: top;
  width: 40px;
  margin-right: 10px;
}

.right-notification-container {
  display: inline-block;
  width: calc(100% - 60px);
}

.notif-img {
  border-radius: 50%;
  height: 40px;
  width: 40px;
  max-width: none;
  /*object-fit: cover;*/
  object-fit: contain;
}

.notification-list-container::-webkit-scrollbar {
  background-color: #fff;
  width: 8px;
}

.notification-list-container::-webkit-scrollbar-thumb {
  background-color: #426dff;
}

.notification-list-container::-webkit-scrollbar-track {
  background-color: #ffffff;
}

.sans-font-style {
  font-family: sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
}

.sans-font-style--size-12 {
  font-family: sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
}
</style>
